import React, { useState } from 'react';

const vehicleNumberRegex = /^[A-Z]{2}\d{2}[A-Z]{1,2}\d{4}$/;

const previousChangesMock = [
  { date: '2025-06-20', type: 'Bike', model: 'Hero Splendor', number: 'MH12AB1234', status: 'Approved' },
  { date: '2025-05-10', type: 'Scooter', model: 'Activa 5G', number: 'MH12XY5678', status: 'Rejected' },
];

function VehicleProfile() {
  const [vehicleData, setVehicleData] = useState({
    type: '',
    model: '',
    number: '',
    photo: null,
  });
  const [isApproved, setIsApproved] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [errors, setErrors] = useState({});

  const handleChange = (field, value) => {
    setVehicleData((prev) => ({ ...prev, [field]: value }));
  };

  const handleUpload = (e) => {
    handleChange('photo', e.target.files[0]);
  };

  const handleSubmit = () => {
    const errs = {};
    if (!vehicleData.type) errs.type = 'Required';
    if (!vehicleData.model) errs.model = 'Required';
    if (!vehicleData.number.match(vehicleNumberRegex)) errs.number = 'Invalid format';
    if (!vehicleData.photo) errs.photo = 'Upload required';

    if (Object.keys(errs).length > 0) {
      setErrors(errs);
      return;
    }

    // Simulate submission
    setShowAlert(true);
    setIsApproved(false); // unverified state after update
    setTimeout(() => setShowAlert(false), 3000);
  };

  return (
    <div className="max-w-2xl mx-auto p-6 bg-white shadow-md rounded-xl space-y-6">
      <h2 className="text-xl font-bold">🚗 Update Vehicle Details</h2>

      <div className="space-y-4">
        <div>
          <label className="block font-medium">Vehicle Type</label>
          <input
            type="text"
            value={vehicleData.type}
            onChange={(e) => handleChange('type', e.target.value)}
            className="w-full border px-3 py-2 rounded"
          />
          {errors.type && <p className="text-red-600 text-sm">{errors.type}</p>}
        </div>

        <div>
          <label className="block font-medium">Model</label>
          <input
            type="text"
            value={vehicleData.model}
            onChange={(e) => handleChange('model', e.target.value)}
            className="w-full border px-3 py-2 rounded"
          />
          {errors.model && <p className="text-red-600 text-sm">{errors.model}</p>}
        </div>

        <div>
          <label className="block font-medium">Vehicle Number</label>
          <input
            type="text"
            placeholder="MH12AB1234"
            value={vehicleData.number}
            onChange={(e) => handleChange('number', e.target.value.toUpperCase())}
            className="w-full border px-3 py-2 rounded"
          />
          {errors.number && <p className="text-red-600 text-sm">{errors.number}</p>}
        </div>

        <div>
          <label className="block font-medium">Upload Photo</label>
          <input type="file" accept="image/*" onChange={handleUpload} />
          {errors.photo && <p className="text-red-600 text-sm">{errors.photo}</p>}
        </div>

        <button
          className="bg-blue-600 text-white px-4 py-2 rounded"
          onClick={handleSubmit}
        >
          Submit for Approval
        </button>

        {!isApproved && (
          <div className="text-red-600 text-sm font-medium">
            🚫 Cannot proceed with deliveries until vehicle is approved.
          </div>
        )}

        {showAlert && (
          <div className="bg-green-100 border border-green-400 text-green-700 px-4 py-2 rounded">
            ✅ Vehicle update submitted. You’ll be notified upon approval.
          </div>
        )}
      </div>

      <div>
        <h3 className="font-semibold mt-6 mb-2">📜 Change History</h3>
        <table className="w-full text-sm border">
          <thead>
            <tr className="bg-gray-100">
              <th className="border px-2 py-1">Date</th>
              <th className="border px-2 py-1">Type</th>
              <th className="border px-2 py-1">Model</th>
              <th className="border px-2 py-1">Number</th>
              <th className="border px-2 py-1">Status</th>
            </tr>
          </thead>
          <tbody>
            {previousChangesMock.map((entry, idx) => (
              <tr key={idx}>
                <td className="border px-2 py-1">{entry.date}</td>
                <td className="border px-2 py-1">{entry.type}</td>
                <td className="border px-2 py-1">{entry.model}</td>
                <td className="border px-2 py-1">{entry.number}</td>
                <td className={`border px-2 py-1 ${entry.status === 'Approved' ? 'text-green-600' : 'text-red-600'}`}>
                  {entry.status}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default VehicleProfile;
